module.exports = __webpack_public_path__ + "static/img/title.36f803a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/title.png
// module id = dqPW
// module chunks = 1